import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { GoogleLogoIcon, MetaColorIcon } from 'components/ui-kit/Icons/svg/index'
import { useThirdPartyLogin } from 'hooks/useThirdParyLogin'
import { usePreLogin } from 'hooks/usePreLogin'

const ThirdPartyLogin = () => {
  const { loginData } = useSelector((state) => state.auth)
  const {
    t,
    checkEthereum,
    googleLogin,
    twitchHyperlink,
    requestPhantomAccount
  } = useThirdPartyLogin()
  const { handleRegister } = usePreLogin()

  return (
    <section className='crypto-won-section'>
      <div className='theme-card-wrap'>
        <div className='theme-card d-lg-flex align-items-center justify-content-between'>
          <h3 className='my-0'>{t('flexibleRegistration')}</h3>
          <div className='payment-options flexible-section'>
            <NavLink to='#' onClick={googleLogin}>
              <GoogleLogoIcon />
            </NavLink>
            <NavLink to='#' onClick={checkEthereum}>
              <MetaColorIcon />
            </NavLink>
            <NavLink to='#' onClick={requestPhantomAccount}>
              <img
                src='/assets/images/homePage/Phantom-color.svg'
                alt='Phantom'
              />
            </NavLink>
            <a href={twitchHyperlink}>
              <img
                src='/assets/images/homePage/twitch-color.svg'
                alt='twitch'
              />
            </a>
          </div>
          {!loginData?.accessToken && (
            <button
              type='button'
              className='btn btn-secondary text-nowrap'
              onClick={handleRegister}
            >
              {t('joinNow')}
            </button>
          )}
        </div>
      </div>
    </section>
  )
}

export default React.memo(ThirdPartyLogin)
